import handler from './handler'
import publicEvaluationOptionUi from './public-evaluation-option-ui'
import tabFeedback from './tab-feedback'
import tabIntroTranslations from './tab-intro-translations'
import tabLogo from './tab-logo'
import tabOverview from './tab-overview'

export default {
    handler,
    publicEvaluationOptionUi,
    tabFeedback,
    tabIntroTranslations,
    tabLogo,
    tabOverview
}
